import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
// import Select from '@material-ui/core/Select';

// import Input from '@material-ui/core/Input';

import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
// import InputLabel from '@material-ui/core/InputLabel';
// import FormControl from '@material-ui/core/FormControl';
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import Dropzone from "react-dropzone";
// import MenuItem from '@material-ui/core/MenuItem';
import domain from "./domain";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "mdbreact";
import moment from "moment-timezone";
import alert from "sweetalert";
const styles = (theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

function getSteps() {
  return ["Step One", "Step Two", "Step Three"];
}

var validExt = ".png, .jpeg, .jpg";
//function for validate file size
var maxSize = "3072";
var previewdesg = {};
var previewdept = {};
var previewproj = {};
var previewrole = {};

class HorizontalLinearStepper extends React.Component {
  constructor() {
    super();
    this.state = {
      completed: new Set(),

      department: null,
      designation: null,
      project: null,
      roles: null,
      activeStep: 0,
      skipped: new Set(),
      empcode: null,
      name: null,
      empdepartment: null,
      empdesignation: null,
      empproject: [],
      emprole: null,
      fndesg: null,
      mobile: null,
      landline: "",
      email: null,
      username: null,
      password: null,
      confpassword: null,
      photo: null,
      uploaded: 0,
      file: null,
      modal: false,
      doj: null,
      dbusername: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleProjectChange = this.handleProjectChange.bind(this);
  }

  handleProjectChange = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({
      empproject: value,
    });
  };

  onDrop([file]) {
    this.setState({
      file: file,
    });
  }

  toggleSubmit = () => {
    if (this.state.mobile) {
      let rephone = /[0-9]{10}/;

      if (!rephone.test(this.state.mobile)) {
        alert("Mobile number must contain 10 digits");
        document.getElementById("phone").focus();
        return false;
      }
    }
    if (this.state.email) {
      let reemail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;

      if (!reemail.test(this.state.email)) {
        alert(
          "Email should contain characters@characters.domain (characters followed by an @ sign, followed by more characters, and then a ."
        );
        document.getElementById("email").focus();
        return false;
      }
    }
    if (this.state.username) {
      if (!this.userNameCheck(this.state.username)) return false;
    }

    if (this.state.password && this.state.confpassword) {
      let rep = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
      if (!rep.test(this.state.password)) {
        alert(
          "Password must contain at least one number,one special character and one uppercase and lowercase letter, and at least 8 or more characters"
        );
        document.getElementById("password").focus();
        return false;
      }
      //   this.handlePassword()
    }

    if (
      this.state.mobile &&
      this.state.email &&
      this.state.username &&
      this.state.password &&
      this.state.confpassword &&
      this.state.file
    ) {
      if (this.validateFile(this.state.file) && this.handlePassword()) {
        return true;
      } else {
        return false;
      }
    }

    if (!this.state.mobile) {
      alert({
        title: "Error",
        text: "Mobile number is empty",
        icon: "error",
      });
      document.getElementById("phone").focus();
      return false;
    }
    if (!this.state.email) {
      alert({
        title: "Error",
        text: "Email id is empty",
        icon: "error",
      });
      document.getElementById("email").focus();
      return false;
    }
    if (!this.state.username) {
      alert({
        title: "Error",
        text: "User name is empty",
        icon: "error",
      });
      document.getElementById("username").focus();
      return false;
    }
    if (!this.state.password) {
      alert({
        title: "Error",
        text: "Password is empty",
        icon: "error",
      });
      document.getElementById("password").focus();
      return false;
    }
    if (!this.state.confpassword) {
      alert({
        title: "Error",
        text: "Confirm password is empty",
        icon: "error",
      });
      document.getElementById("confpassword").focus();
      return false;
    }
    if (!this.state.file) {
      alert({
        title: "Error",
        text: "Please upload photo",
        icon: "error",
      });
      document.getElementById("photo").focus();
      return false;
    }
  };

  toggle = () => {
    if (this.state.mobile) {
      let rephone = /[0-9]{10}/;

      if (!rephone.test(this.state.mobile)) {
        alert({
          title: "Error",
          text: "Mobile number must contain 10 digits",
          icon: "error",
        });
        // alert('');
        document.getElementById("phone").focus();
        return false;
      }
    }
    if (this.state.email) {
      let reemail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/;

      if (!reemail.test(this.state.email)) {
        alert({
          title: "Error",
          text:
            "Email should contain characters@characters.domain (characters followed by an @ sign, followed by more characters, and then a .",
          icon: "error",
        });
        // alert('')
        document.getElementById("email").focus();
        return false;
      }
    }
    if (this.state.username) {
      if (!this.userNameCheck(this.state.username)) return false;
    }

    if (this.state.password && this.state.confpassword) {
      let rep = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
      if (!rep.test(this.state.password)) {
        alert({
          title: "Error",
          text:
            "Password must contain at least one number,one special character and one uppercase and lowercase letter, and at least 8 or more characters",
          icon: "error",
        });
        // alert('Password must contain at least one number,one special character and one uppercase and lowercase letter, and at least 8 or more characters')
        document.getElementById("password").focus();
        return false;
      }
      //   this.handlePassword()
    }

    if (
      this.state.mobile &&
      this.state.email &&
      this.state.username &&
      this.state.password &&
      this.state.confpassword &&
      this.state.file
    ) {
      if (this.validateFile(this.state.file) && this.handlePassword()) {
        this.setState({
          modal: !this.state.modal,
        });
      }
    }

    if (!this.state.mobile) {
      alert({
        title: "Error",
        text: "Mobile number is empty",
        icon: "error",
      });
      document.getElementById("phone").focus();
      return false;
    }
    if (!this.state.email) {
      alert({
        title: "Error",
        text: "Email id is empty",
        icon: "error",
      });
      document.getElementById("email").focus();
      return false;
    }
    if (!this.state.username) {
      alert({
        title: "Error",
        text: "Username is empty",
        icon: "error",
      });
      document.getElementById("username").focus();
      return false;
    }
    if (!this.state.password) {
      alert({
        title: "Error",
        text: "Password is empty",
        icon: "error",
      });
      document.getElementById("password").focus();
      return false;
    }
    if (!this.state.confpassword) {
      alert({
        title: "Error",
        text: "Confirm Password is empty",
        icon: "error",
      });
      document.getElementById("confpassword").focus();
      return false;
    }
    if (!this.state.file) {
      alert({
        title: "Error",
        text: "Please upload photo",
        icon: "error",
      });
      document.getElementById("photo").focus();
      return false;
    }
  };

  handlePassword = () => {
    if (this.state.password !== this.state.confpassword) {
      alert({
        title: "Error",
        text: "Passwords are not match",
        icon: "error",
      });
      document.getElementById("password").focus();
      return false;
    } else {
      return true;
    }
  };

  validateFile = (photo) => {
    if (this.fileExtValidate(photo) && this.fileSizeValidate(photo))
      return true;
    else return false;
  };

  fileExtValidate = (fdata) => {
    var filePath = fdata.name;

    var getFileExt = filePath
      .substring(filePath.lastIndexOf(".") + 1)
      .toLowerCase();
    var pos = validExt.indexOf(getFileExt);
    if (pos < 0) {
      alert({
        title: "Error",
        text:
          "This file is not allowed, please upload valid file. Allowed file formats are .png , .jpg,.jpeg",
        icon: "error",
      });
      // alert("");
      return false;
    } else {
      return true;
    }
  };

  fileSizeValidate = (fdata) => {
    if (fdata.size) {
      var fsize = fdata.size / 1024;
      // alert(fsize)
      if (fsize > maxSize) {
        alert({
          title: "Error",
          text:
            "Maximum file size exceeds, Allowed file size is: " + fsize + "KB",
          icon: "error",
        });
        //  alert('Maximum file size exceeds, Allowed file size is: ' + fsize + "KB");
        return false;
      } else {
        return true;
      }
    }
  };
  async fetchUserName() {
    let result = await axios.get(`${domain.DBServer}/fetch-user`);

    if (result.data) {
      this.setState({
        dbusername: result.data,
      });
    }
  }
  userNameCheck = (username) => {
    let status = 1;
    if (this.state.dbusername) {
      this.state.dbusername.some((user, key) => {
        if (user.username === username) status = 0;
        return true;
      });
      //warning
      return true;
    }
    if (status === 0) {
      alert({
        title: "Error",
        text: "username is available. Choose another",
        icon: "error",
      });

      document.getElementById("username").focus();
      return false;
    } else {
      return true;
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();

    this.toggleSubmit();

    if (
      this.state.file &&
      this.state.salutation &&
      this.state.name &&
      this.state.empcode &&
      this.state.empdesignation &&
      this.state.empdepartment &&
      this.state.doj &&
      this.state.empproject &&
      this.state.emprole &&
      this.state.mobile &&
      this.state.username &&
      this.state.password &&
      this.state.email
    ) {
      //this.toggle
      var data = new FormData();
      let employee_details = {
        empsalutation: this.state.salutation,
        empcode: this.state.empcode,
        empname: this.state.name,
        empdesignation: this.state.empdesignation,
        empdepartment: this.state.empdepartment,
        empproject: [this.state.empproject],
        emprole: this.state.emprole,
        empdoj: this.state.doj,
        empemail: this.state.email,
        empmobile: this.state.mobile,
        emplandline: this.state.landline,
        empfuncdesg: this.state.fndesg,
        empusername: this.state.username,
        emppassword: this.state.password,
      };
      //  console.log(employee_details)

      data.append("photo", this.state.file);
      if (employee_details) {
        for (let key in employee_details) {
          data.append(key, employee_details[key]);
        }
      }
      //console.log(data)
      var config = {
        onUploadProgress: (progressEvent) => {
          this.setState({
            uploaded: progressEvent.loaded / progressEvent.total,
          });
        },
      };

      axios
        .post(`${domain.DBServer}/insert-employee`, data, config)
        .then((res) => {
          // console.log(res)

          this.setState({
            uploaded: 1,
          });
          if (res.data.success) {
            alert({
              title: "Success",
              text: res.data.msg,
              icon: "success",
            });
            // alert(res.data.msg);
            this.props.history.replace("/login");
          } else {
            alert({
              title: "Error",
              text: res.data.msg,
              icon: "error",
            });
            //   alert(res.data.msg)

            this.props.history.replace("/login");
          }
        })
        .catch((err) => {
          this.setState({
            error: err.message,
          });
        });
    }
  };

  getStepContent = (step) => {
    let designationoptions, departmentoptions, rolesoptions, projectoptions;
    //   let mdesg,mdept,mproj,mroles
    if (this.state.designation) {
      designationoptions = this.state.designation.map((designation, key) => {
        previewdesg[designation.desgn_id] = designation.title;
        return (
          <option key={key} value={designation.desgn_id}>
            {designation.title}
          </option>
        );
      });
      console.log(previewdesg);
    }
    if (this.state.department) {
      departmentoptions = this.state.department.map((department, key) => {
        previewdept[department.dep_id] = department.name;
        return (
          <option key={key} value={department.dep_id}>
            {department.name}
          </option>
        );
      });
    }
    if (this.state.project) {
      projectoptions = this.state.project.map((project, key) => {
        previewproj[project.act_id] = project.name;
        return (
          <option key={key} value={project.act_id}>
            {project.name}
          </option>
        );
      });
    }
    if (this.state.roles) {
      rolesoptions = this.state.roles.map((role, key) => {
        previewrole[role.role_id] = role.title;
        return (
          <option key={key} value={role.role_id}>
            {role.title}
          </option>
        );
      });
    }

    switch (step) {
      case 0:
        return (
          <div>
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <h2>Register New User</h2>

                <hr />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Salutation<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-user-o"></i>
                    </div>
                    <select
                      className="custom-select"
                      id="salutation"
                      name="salutation"
                      value={this.state.salutation}
                      onChange={this.handleChange}
                      selected={this.state.salutation}
                    >
                      <option selected value="">
                        Choose One...
                      </option>
                      <option value="Mr">Mr</option>
                      <option value="Ms">Ms</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Dr">Dr</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Name<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-user-circle"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="text"
                      name="name"
                      id="name"
                      className="form-control"
                      required
                      autoFocus
                      onChange={this.handleChange}
                      value={this.state.name || ""}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-control-feedback">
                  <span className="text-danger align-middle"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Employee Code<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-id-card"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="text"
                      name="empcode"
                      className="form-control"
                      id="empcode"
                      required
                      autoFocus
                      onChange={this.handleChange}
                      value={this.state.empcode || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Designation<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-certificate"></i>
                    </div>
                    <select
                      className="custom-select"
                      id="empdesignation"
                      name="empdesignation"
                      onChange={this.handleChange}
                      defaultValue={this.state.empdesignation}
                      value={this.state.empdesignation || ""}
                    >
                      {designationoptions}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Department<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-address-card"></i>
                    </div>
                    <select
                      className="custom-select"
                      id="empdepartment"
                      name="empdepartment"
                      defaultValue={this.state.empdepartment}
                      onChange={this.handleChange}
                      value={this.state.empdepartment || ""}
                    >
                      {departmentoptions}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Date of Joining in NHP<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-calendar"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="date"
                      name="doj"
                      className="form-control"
                      required
                      autoFocus
                      onChange={this.handleChange}
                      id="doj"
                      value={this.state.doj || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Project
                  <span style={{ color: "red" }}>
                    *(<i>Use Ctrl + right click for multiple selections</i>)
                  </span>
                </label>
              </div>
              <div className="col-md-8">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    ></div>
                    <select
                      multiple="true"
                      className="custom-select"
                      name="empproject"
                      id="empproject"
                      onChange={this.handleProjectChange}
                      value={this.state.empproject}
                    >
                      {projectoptions}
                    </select>
                    {/* <FormControl>
          <InputLabel htmlFor="select-multiple">Name</InputLabel>
          <Select
            multiple
            value={this.state.empproject}
            onChange={this.handleChange}
            input={<Input id="select-multiple" />}
            
          >
          {names.map(name => (
              <MenuItem
                key={name}
                value={name}
                
              >
                {name}
              </MenuItem>
            ))}
          
          </Select>
          </FormControl> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="name">
                  Role<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i></i>
                    </div>
                    <select
                      className="custom-select"
                      name="emprole"
                      id="emprole"
                      onChange={this.handleChange}
                      selected={this.state.emprole}
                      value={this.state.emprole}
                    >
                      {rolesoptions}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="email">Functional Designation</label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="text"
                      name="fndesg"
                      className="form-control"
                      id="fndesg"
                      placeholder="Ex: Head, Group Head, etc."
                      value={this.state.fndesg || ""}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-control-feedback">
                  <span className="text-danger align-middle">Optional</span>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="email">
                  Mobile Number<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-mobile"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="tel"
                      name="mobile"
                      className="form-control"
                      id="phone"
                      placeholder="Mobile Number should contain 10 digits"
                      required
                      autoFocus
                      onChange={this.handleChange}
                      value={this.state.mobile}
                      pattern="[0-9]{10}"
                      title="Mobile number must contain 10 digits"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-control-feedback">
                  <span
                    className="text-danger align-middle"
                    id="mobiletip"
                  ></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="email">Landline Number</label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-phone"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="text"
                      name="landline"
                      className="form-control"
                      id="landline"
                      placeholder="Ex:040-28334552"
                      value={this.state.landline}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-control-feedback">
                  <span className="text-danger align-middle">Optional</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="email">
                  E-Mail Address<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-at"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="text"
                      name="email"
                      className="form-control"
                      id="email"
                      required
                      placeholder="Ex:test@gmail.com/test@nrsc.gov.in"
                      value={this.state.email || ""}
                      onChange={this.handleChange}
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                      title="characters@characters.domain (characters followed by an @ sign, followed by more characters, and then a ."
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-control-feedback">
                  <span className="text-danger align-middle"></span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="email">
                  Username<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-user"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="text"
                      name="username"
                      className="form-control"
                      id="username"
                      placeholder=""
                      value={this.state.username}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-control-feedback">
                  <span className="text-danger align-middle"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="password">
                  Password<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group has-danger">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-key"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="password"
                      name="password"
                      className="form-control"
                      id="password"
                      placeholder="Must contain at least one number,one special character and one uppercase and lowercase letter, and at least 8 or more characters"
                      value={this.state.password}
                      required
                      onChange={this.handleChange}
                      pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                      title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                    />
                    {/* <input autoComplete="on" type="password" name="password" className="form-control" id="password"
                                       placeholder="Password" value={this.state.password} required onChange={this.handleChange} />    */}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="password">
                  Confirm Password<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-repeat"></i>
                    </div>
                    <input
                      autoComplete="on"
                      type="password"
                      name="confpassword"
                      className="form-control"
                      id="confpassword"
                      placeholder="Password"
                      value={this.state.confpassword}
                      required
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 field-label-responsive">
                <label htmlFor="password">
                  Upload Photo<span style={{ color: "red" }}>*</span>
                </label>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                    <div
                      className="input-group-addon"
                      style={{ width: "2.6rem" }}
                    >
                      <i className="fa fa-upload"></i>
                    </div>
                    {/* <input autoComplete="on" type="file" name="photo" className="form-control-file" id="photo" aria-describedby="fileHelp" onChange={this.handleFileUpload} required /> */}
                    <div
                      style={{
                        float: "left",
                        width: "calc(100% + 30px)",
                        textAlign: "center",
                        backgroundColor: "#fafafa",
                        margin: "0 -15px 15px",
                        padding: "15px",
                        boxShadow: "0 0 2px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      <Dropzone
                        multiple={false}
                        ref={(node) => {
                          this.dropzone = node;
                        }}
                        onDrop={this.onDrop}
                        id="photo"
                        style={{
                          width: "calc(100% + 10px)",
                          height: "250px",
                          borderWidth: 2,
                          borderColor: "rgb(102, 102, 102)",
                          borderStyle: "dashed",
                          borderRadius: 5,
                          margin: "16px auto",
                        }}
                      >
                        Drag and drop a image file to start uploading.
                        <br />
                        <br />
                        <div className="alert alert-warning">
                          The file format can be .png, .jpeg or .jpg. The file
                          size cannot exceed 3MB
                        </div>
                        <Button type="button">Upload Photo</Button>
                        <br />
                        {this.state.file != null ? (
                          <div>
                            <img
                              src={URL.createObjectURL(this.state.file)}
                              width="70"
                              height="70"
                              alt=""
                            />
                            <h5>
                              Uploading {this.state.file.name} (
                              {(this.state.uploaded * 100).toFixed(2)}%)
                            </h5>
                          </div>
                        ) : null}
                        <div></div>
                      </Dropzone>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return 0;
    }
  };
  handleChange = (e) => {
    e.preventDefault();
    e = e.target;
    this.setState({
      [e.name]: e.value,
    });
  };

  handleFileUpload = (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    console.log(file);
    this.setState({
      photo: file,
    });
  };

  async fetchDeptDesgProjRoles() {
    let result = await axios.all([
      axios.get(`${domain.DBServer}/fetch-department`),
      axios.get(`${domain.DBServer}/fetch-designation`),
      axios.get(`${domain.DBServer}/fetch-project`),
      axios.get(`${domain.DBServer}/fetch-roles`),
    ]);

    if (result) {
      this.setState({
        department: result[0].data,
        designation: result[1].data,
        project: result[2].data,
        roles: result[3].data,
        empdepartment: result[0].data[0].dep_id,
        empdesignation: result[1].data[0].desgn_id,
        empproject: [result[2].data[0].act_id],
        emprole: result[3].data[0].role_id,
      });
    } else {
      alert("Network Error");
    }
  }
  componentDidMount() {
    this.fetchDeptDesgProjRoles();
    this.fetchUserName();
  }

  isStepOptional = (step) => {
    return step === 4;
  };

  handleNext = () => {
    const { activeStep } = this.state;
    let { skipped } = this.state;

    if (this.isStepSkipped(activeStep)) {
      skipped = new Set(skipped.values());
      skipped.delete(activeStep);
    }
    // console.log(this.state)
    if (
      this.state.empcode &&
      this.state.name &&
      this.state.empdepartment &&
      this.state.empdesignation &&
      this.state.doj &&
      this.state.salutation
    ) {
      var a = moment(this.state.doj);

      let b = moment();

      let diff = a.diff(b, "days");

      let re = /[N][R][0-9]{5}/i;
      if (!re.test(this.state.empcode)) {
        alert({
          title: "Error",
          text:
            "Employee Code should start with NR and should be preceded by 5 digits.",
          icon: "error",
        });
        // alert("Employee Code should start with NR and should be preceded by 5 digits.")
        document.getElementById("empcode").focus();
      } else if (diff > 0) {
        alert({
          title: "Error",
          text: "The date selected cannot be greater than today's date",
          icon: "error",
        });
        // alert("The date selected cannot be greater than today's date")
        return false;
      } else {
        this.setState({
          activeStep: activeStep + 1,
          skipped,
        });
        return true;
      }
    } else {
      this.setState({
        activeStep: activeStep,
        skipped,
      });
      this.validate(
        this.state.empcode,
        this.state.name,
        this.state.empdepartment,
        this.state.empdesignation,
        this.state.doj,
        this.state.salutation,
        this.state.photo,
        this.state.mobile
      );
    }
  };
  validate(
    empcode,
    name,
    empdepartment,
    empdesignation,
    doj,
    salutation,
    photo,
    mobile
  ) {
    if (!salutation) {
      alert({
        title: "Error",
        text: "employee salutation is not selected... Please select",
        icon: "error",
      });
      // alert('employee salutation is not selected... Please select')
      document.getElementById("salutation").focus();
    } else if (!name) {
      alert({
        title: "Error",
        text: "employee name is empty... Please fill",
        icon: "error",
      });
      // alert('')
      document.getElementById("name").focus();
    } else if (!empcode) {
      alert({
        title: "Error",
        text: "employee code is empty... Please fill",
        icon: "error",
      });
      // alert('employee code is empty... Please fill')
      document.getElementById("empcode").focus();
    } else if (!doj) {
      alert({
        title: "Error",
        text: "Please select date of joining...",
        icon: "error",
      });
      // alert('')
      document.getElementById("doj").focus();
    }
  }

  handleBack = () => {
    const { activeStep } = this.state;

    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    if (!this.isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState((state) => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }

  render() {
    let previewprojectshow;
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;
    if (this.state.empproject) {
      // console.log(this.state.empproject)
      previewprojectshow = this.state.empproject.map((result, key) => {
        return <p key={key}>{previewproj[result]}</p>;
      });
    }

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const props = {};
            const labelProps = {};
            if (this.isStepOptional(index)) {
              labelProps.optional = (
                <Typography variant="caption">Optional</Typography>
              );
            }
            if (this.isStepSkipped(index)) {
              props.completed = false;
            }
            return (
              <Step key={label} {...props}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions}>
                All steps completed - you&quot;re finished
              </Typography>
              {/* <Button onClick={this.handleReset} className={classes.button}>
                Reset
              </Button> */}
            </div>
          ) : (
            <div>
              <div className="container">
                <form
                  className="form-horizontal"
                  method="post"
                  encType="multipart/form-data"
                  onSubmit={this.handleSubmit}
                >
                  {this.getStepContent(activeStep)}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="alert alert-danger"
                      style={{ display: "inline-block" }}
                    >
                      All fields indicated with (*) are mandatory
                    </div>{" "}
                    &nbsp;&nbsp;
                    {/* <h6 style={{float:"left",color:"red"}}>(*) indicates mandatory field &nbsp; &nbsp;</h6> */}
                    <Button
                      variant="raised"
                      color="primary"
                      disabled={activeStep === 0}
                      onClick={this.handleBack}
                      className={classes.button}
                      style={{ display: "inline-block" }}
                    >
                      Back
                    </Button>
                    {this.isStepOptional(activeStep) && (
                      <Button
                        variant="raised"
                        color="primary"
                        onClick={this.handleSkip}
                        className={classes.button}
                        style={{ display: "inline-block" }}
                      >
                        Skip
                      </Button>
                    )}
                    <Button
                      variant="raised"
                      color="primary"
                      onClick={
                        activeStep === steps.length - 1
                          ? this.toggle
                          : this.handleNext
                      }
                      className={classes.button}
                      style={{ display: "inline-block" }}
                    >
                      {activeStep === steps.length - 1 ? "Preview" : "Next"}
                    </Button>
                    <Modal
                      isOpen={this.state.modal}
                      toggle={this.toggle}
                      size="lg"
                    >
                      <ModalHeader toggle={this.toggle}>
                        {this.state.name}
                      </ModalHeader>
                      <ModalBody>
                        <div
                          className="modal-body"
                          style={{ fontFamily: "Helvetica" }}
                        >
                          <table
                            className="table table-bordered table-responsive-md"
                            cellSpacing="0"
                            width="60%"
                          >
                            <tbody>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>Name </td>
                                <td>{this.state.name}</td>
                                <td
                                  rowSpan="3"
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "center",
                                  }}
                                >
                                  {this.state.file != null ? (
                                    <img
                                      src={URL.createObjectURL(this.state.file)}
                                      width="100"
                                      height="100"
                                      alt=""
                                    />
                                  ) : (
                                    "image not uploaded"
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Employee Code
                                </td>
                                <td>{this.state.empcode}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Designation
                                </td>
                                <td>
                                  {" "}
                                  {previewdesg[this.state.empdesignation]}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Department
                                </td>
                                <td>{previewdept[this.state.empdepartment]}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Date of Joining{" "}
                                </td>
                                <td>{moment(this.state.doj).format("LL")}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>Project</td>

                                <td>{previewprojectshow}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>Role</td>
                                <td>{previewrole[this.state.emprole]}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Functional Designation
                                </td>
                                <td>{this.state.fndesg}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Mobile Number
                                </td>
                                <td>{this.state.mobile}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>
                                  Landline Number
                                </td>
                                <td>{this.state.landline}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>Email</td>
                                <td>{this.state.email}</td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: "bold" }}>Username</td>
                                <td>{this.state.username}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="danger" onClick={this.toggle}>
                          Close
                        </Button>{" "}
                      </ModalFooter>
                    </Modal>
                    {activeStep === steps.length - 1 ? (
                      <Button
                        variant="raised"
                        color="secondary"
                        type="submit"
                        className={classes.button}
                      >
                        <i className="fa fa-user-plus"></i> Submit &amp;
                        Register
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

HorizontalLinearStepper.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(HorizontalLinearStepper);
